export const gstConstants = {
  G_S_T_ACCOUNTS_LOADED: 'G_S_T_ACCOUNTS_LOADED',
  G_S_T_ACCOUNT_LOADED: 'G_S_T_ACCOUNT_LOADED'
};



// WEBPACK FOOTER //
// ./src/_constants/gst.constants.js